/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useLayoutEffect } from "react";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
// import ApolloClient from "apollo-boost";
import { ApolloProvider, ApolloClient, InMemoryCache, makeVar, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { useQuery } from "@apollo/client";
import { Route, Switch, useLocation } from "react-router-dom";
// import { InMemoryCache } from "apollo-cache-inmemory";
import { useDeviceToken } from 'custom_hooks/useDeviceToken';
import Courses from "../courses";
import CourseDetail from "../courses/course-detail";
import CategoryCourses from 'components/courses/courses-categoty';
import Rules from "../rules/rules";
import DataProtection from "../rules/data-protection";
import FAQ from "../rules/FAQ";
import AGB from "components/rules/agb";

import NewsLetter from "../rules/newsletter";
import Lections from "../lections";
import PlayLection from "../lections/play-lection-container";
import PlayLectionVideo from "components/lections/play-lection-video";
import PlayLectionAudio from "components/lections/play-lection-audio";
import PlayLectionPdf from "components/lections/play-lection-pdf";
import Questionnaire from "../lections/questionnaire";
import Login from "../login";
import Trainer from "../trainer";
import Home from "../home";
import Points from "../points";
import Profile from "../profile";
import News from "../news";
import Coupons from "../coupons";
import CouponCampaignDetail from "../coupons/coupon-campaign-detail";
import MyCoupons from "../coupons-my/coupons";
import SuccessfulPurchase from "../coupons/successful-purchase";
import Edit from "../profile/edit";
import Registration from "../registration";
import InternalLayout from "../internal-layout";
import Progress from "../progress";
import Welcome from "../welcome";
import Success from "../finished/success";
import Failed from "../finished/failed";
import NewsFeedList from "../news/EntriesList.js";
import {Certificates} from '../achievements/certificates';
import SurveyList from "components/Surveys/SurveyList";

import { IS_LOGGED_IN } from "../../queries/queries";
import Surveys from "components/Surveys";
import SurveyDetail from "components/Surveys/SurveyDetail";
import SurveyProvider from "components/Surveys/QuestionFlow/QuestionContext";
import CouponsList from "components/achievements/gifts";
import ProfilePoints from "components/achievements/points";
import AppointmentBook from "components/appointments/appointment-book";
import ThankYouPage from "components/thankyou/thankyou-page";
import MessageToTrainer from "components/trainer/trainer-message";
import ProfileEdit from "components/profile/profile-edit";
import CoursesResult from "components/courses/courses-result";
import AppointmentDetail from "components/appointments/appointment-details";
import AppointmentsList from "components/appointments/appointments-list";
import AppointmentsSuggestion from "components/appointments/appointment-suggestion";
import MyCouponCampaignDetail from "components/coupons/my-coupon-campaign-details";
import Impressum from "components/rules/impressum";
import FavoritesList from "components/news/FavoritesList";
import HcpPortals from 'components/hcp-portals/hcp-portal';
import GiveawayDetail from 'components/giveaway/giveaway-details';
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import GiveawayList from 'components/giveaway/giveaway-list';

const URI = process.env.REACT_APP_BACKEND_URL;
export const isLoggedInVar = makeVar(!!localStorage.getItem("token"));

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        isLoggedIn: {
          read() {
            return isLoggedInVar();
          },
        },
      },
    },
  },
});

const httpLink = createHttpLink({
  uri: URI,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token");

  return {
    headers: {
      ...headers,
      authorization: token ? token : "",
    },
  };
});

const uploadLink = createUploadLink({ uri: URI });


const client = new ApolloClient({
  link: authLink.concat(uploadLink), // order: auth -> upload
  cache,
});


const InternalPages = ({ props }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top:0, left:0, behavior: "instant" });
}, [location.pathname]);
  return (
    <>
      <SurveyProvider>
        <InternalLayout exact path="/" component={Home} />
        <InternalLayout path="/courses" component={Courses} exact />
        <Route path="/lections/success/:lectionId" component={Success} />
        <Route path="/lections/failed/:lectionId" component={Failed} />
        <InternalLayout path="/courses/:courseId" component={CourseDetail} exact />
        <InternalLayout path="/course_details/:courseId" component={CourseDetail} />
        <InternalLayout path="/giveaway/:id" component={GiveawayDetail} />
        <InternalLayout path="/category_courses/:categoryId" component={CategoryCourses} />
        <InternalLayout
          path="/lections/questionnaire/:lectionId"
          component={Questionnaire}
          exact
        />
        <InternalLayout path="/surveys/" component={Surveys} />
        <InternalLayout
          path="/survey_details/:surveyId"
          component={SurveyDetail}
          exact
        />
        <InternalLayout path="/trainer" component={Trainer} />
        <InternalLayout path="/appointment-book" component={AppointmentBook} />
        <InternalLayout path="/appointment-details/:appointmentId" component={AppointmentDetail} />
        <InternalLayout path="/appointments-suggestion" component={AppointmentsSuggestion} />
        <InternalLayout path="/appointments-list" component={AppointmentsList} />
        <InternalLayout path="/courses-result" component={CoursesResult} />
        <InternalLayout path="/trainer-message" component={MessageToTrainer} />
        <InternalLayout path="/thank-you" component={ThankYouPage} />
        <InternalLayout path="/profile" component={Profile} />
        <InternalLayout path="/news" component={News} />
        <InternalLayout path="/coupons-list" component={CouponsList} />
        <InternalLayout path="/profile-points" component={ProfilePoints} />
        <InternalLayout path="/coupons" component={Coupons} />
        <InternalLayout path="/my-coupon/:campaignId" component={MyCouponCampaignDetail} />
        <InternalLayout path="/certificates" component={Certificates} />
        <InternalLayout path="/surveys-list" component={SurveyList} />
        <InternalLayout path="/hcp-portale" component={HcpPortals} />
        <InternalLayout path="/giveaway-list" component={GiveawayList} />
        <InternalLayout path="/my-coupons" component={MyCoupons} />
        <InternalLayout path="/coupon/:campaignId" component={CouponCampaignDetail} />
        {/* <Route
          path="/my-coupon/:campaignId"
          component={MyCouponCampaignDetail}
        /> */}
        <Route
          path="/successful-purchase/:campaignId"
          component={SuccessfulPurchase}
        />
        <InternalLayout path="/edit_profile" component={Edit} />
        <InternalLayout path="/profile-edit" component={ProfileEdit} />
        <InternalLayout path="/points/:subRoute?" component={Points} />
        <InternalLayout path="/progress" component={Progress} />
      </SurveyProvider>
    </>
  );
};

const IsLoggedIn = () => {
  const [isTokenSubmittedToWrapper, setIsTokenSubmittedToWrapper] = useState(
    false
  );

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (window.ReactNativeWebView && !isTokenSubmittedToWrapper && token) {
      window.ReactNativeWebView.postMessage(localStorage.getItem("token"));
      setIsTokenSubmittedToWrapper(true);
    }
  }, [token]);


  const handleLoggedIn = () => {
    isLoggedInVar(true);
    if (window.ReactNativeWebView && !isTokenSubmittedToWrapper) {
      window.ReactNativeWebView.postMessage(!!localStorage.getItem("token"));
      setIsTokenSubmittedToWrapper(true);
    }
  };

  const { data } = useQuery(IS_LOGGED_IN);


  const { isLoggedIn } = data;

  return isLoggedIn ? (
    <InternalPages />
  ) : (
    <Login handleLoggedIn={handleLoggedIn} />
  );
};

function App() {
  useDeviceToken();
  const theme = createTheme({
    typography: {
      fontFamily: ["Montserrat"],
      h1: {
        fontSize: 26,
        fontWeight: 300,
      },
      h2: {
        fontSize: 40,
        fontWeight: 600,
      },
    },
    colors: {
      white: "#fff",
    },
    shadows: ["0px 0px #00000021"],
    palette: {
      background: {
        light: "#f6f5f6",
      },
      primary: {
        main: "#008dbc",
      },
      secondary: {
        main: "#756f72",
        button: "#FFAB9D",
      },
      button: {
        main: "#FFAB9D",
      },
    },
  });


  useEffect(() => {
  const handleMessage = (message) => {
    const data = message.data;

    if (typeof data !== "string") return;
    const token = data.trim();

    const isLikelyJSON = token.startsWith("{") || token.startsWith("[");
    const tooShort = token.length < 40;
    const hasSpace = token.includes(" ");

    if (isLikelyJSON || tooShort || hasSpace) {
      return;
    }

    localStorage.setItem("deviceToken", token);
    console.log("Device token saved:", token);
  };

  window.addEventListener("message", handleMessage);
  return () => window.removeEventListener("message", handleMessage);
  }, []); 


  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
       
          <ApolloProvider client={client}>
            <Switch>
              <InternalLayout path="/rules" component={Rules} />
              <InternalLayout path="/data-protection" component={DataProtection} />
              <InternalLayout path="/agb" component={AGB} />
              <InternalLayout path="/impressum" component={Impressum} />
              <InternalLayout path="/faq" component={FAQ} />
              <Route path="/newsletter" component={NewsLetter} />
              <Route path="/registration/:code?" component={Registration} />
              <InternalLayout
                exact
                path="/news/:id"
                component={NewsFeedList}
              />
              <InternalLayout
                exact
                path="/favorites"
                component={FavoritesList}
              />
              <Route path="/welcome/:pharmacyName" component={Welcome} />
              <Route path="/welcome/:pharmacyName" component={Welcome} />
              <Route
                path="/lections/playLection/:lectionId"
                component={PlayLection}
              />
              <InternalLayout path="/lections/playLectionVideo/:lectionId" component={PlayLectionVideo} />
              <InternalLayout path="/lections/playLectionAudio/:lectionId" component={PlayLectionAudio} />
              <InternalLayout path="/lections/playLectionPdf/:lectionId" component={PlayLectionPdf} />
              <IsLoggedIn />
            </Switch>
          </ApolloProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
